// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconPaperclip = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 18C10 10.2803 16.2803 4 24 4C31.7197 4 38 10.2803 38 18C38 27.875 40.0688 31.0732 41.731 33.6445C42.8467 35.3691 44 37.1533 44 40C44 44.9629 39.9624 49 35 49C26.2794 49 20.5121 39.2939 20.0324 24.0827C19.9966 22.9477 20.8989 22 22.0344 22H24.0405C25.1105 22 25.9959 22.8426 26.0346 23.912C26.3883 33.6872 29.4524 43 35 43C36.6543 43 38 41.6543 38 40C38 38.9766 37.6641 38.4043 36.6924 36.9023C34.8237 34.0127 32 29.6455 32 18C32 13.5889 28.4111 10 24 10C19.5889 10 16 13.5889 16 18C16 27.0778 17.3701 53 35 53C42.1685 53 48 47.168 48 40C48 36.6934 46.876 34.8838 45.4536 32.5918C44.0909 30.3972 42.5755 27.9564 42.1298 24.2399C41.9872 23.0508 42.9229 22 44.1204 22H46.137C47.1228 22 47.9762 22.7195 48.1098 23.6962C48.4257 26.0042 49.3886 27.5554 50.5508 29.4268C52.1675 32.0312 54 34.9824 54 40C54 50.4766 45.4766 59 35 59C19.5796 59 10 44.5191 10 18Z" />
    </svg>
  );
};
